import { useAppDispatch } from '@hooks'
import {
  api,
  CustomerRoles,
  useMerchantQry,
  useMerchantsForSwitchQry,
  useSwitchMerchantMutation,
  useUserProfileQry
} from 'mmfintech-backend-api'

export const useCompanySwitch = () => {
  const dispatch = useAppDispatch()

  const { merchant } = useMerchantQry()
  const { profile } = useUserProfileQry()
  const { subAccounts } = useMerchantsForSwitchQry()

  const [switchMerchant, { isLoading: switching }] = useSwitchMerchantMutation()

  const currentMerchantId = merchant?.merchantId
  const canSwitchCompany = profile?.customerRole !== CustomerRoles.STAFF && subAccounts.length > 1

  const switchCompany = async (targetMerchantId: number) => {
    if (switching || targetMerchantId === currentMerchantId) {
      return
    }
    try {
      await switchMerchant({ merchantId: targetMerchantId }).unwrap()
      dispatch(api.util.resetApiState())
    } catch (_error) {}
  }

  return {
    companies: subAccounts,
    canSwitchCompany,
    currentMerchantId,
    parentMerchantId: merchant?.parentMerchantId ?? currentMerchantId,
    switchCompany
  }
}
